/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { GlobalContext } from 'shared/context/store';
import { PATH } from 'shared/constants';

const PublicRoute = ({ component: Component, ...rest }) => {
  const { state: { rootState } } = useContext(GlobalContext);
  const { clientData } = rootState;
  if (clientData.token) {
    return (
      <Redirect
        to={PATH.DASHBOARD}
      />
    );
  }
  return (
    <Route
      {...rest}
      render={(props) => (
        <Component {...props} />
      )}
    />
  );
};

export default PublicRoute;
